import { render, staticRenderFns } from "./DefaultHeaderDropdownNotif.vue?vue&type=template&id=10672a9a"
import script from "./DefaultHeaderDropdownNotif.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownNotif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports